import React from 'react'
import styled from 'styled-components'

const UnderConstruction = styled.div`
  min-height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 20px;

  p {
    margin: 0 0 16px;
    font-size: 22px;
    color: #4b5563;
  }

  h1 {
    margin: 0;
    font-size: clamp(42px, 6vw, 82px);
    font-weight: 800;
    letter-spacing: 3px;
    color: #00552e;
  }
`

const IPNPopulation = () => (
    <UnderConstruction>
        <p>OPPS! Nothing to see here yet!</p>
        <h1>UNDER CONSTRUCTION</h1>
    </UnderConstruction>
)

export default IPNPopulation